// extracted by mini-css-extract-plugin
module.exports = {"jobCard-applyButton__subText":"jobCard-applyButton__subText"};